import React, {useEffect, useState, useContext} from "react";
import {useSearchParams} from "react-router-dom";
import {host, socket} from "../libs/webRTC";
import {Box, Button} from "@mui/material"
import StudentsTable from "../components/studentslist/StudentsTable";
import axios from "../libs/httpClient";
import fronLogger from "../libs/logger";


export default function LogTable(props) {
    const [logFilters, setLogFilters] = useState({});
    const [searchParams] = useSearchParams();
    function parse_data(){
        let token = document.getElementById("token").value;
        let message = document.getElementById("message").value;
        let file = document.getElementById("file").value;
        let date = document.getElementById("date").value;
        let error = document.getElementById("error").value;
        let source = document.getElementById("source").value;


        let data = {
            "token": document.getElementById("token").value,
            "message": document.getElementById("message").value,
            "file": document.getElementById("file").value,
            "date": document.getElementById("date").value,
            "error": document.getElementById("error").value,
            "source": document.getElementById("source").value,
        }

        request(data);
    }

    function request(data = {}) { setLogFilters(data); }


    useEffect(() => {
        let token = '';
        const tokenFromQuery = searchParams.get("token");
        if (tokenFromQuery) {
            const tokenInput = document.getElementById("token");
            if (tokenInput) {
                console.log(tokenInput);
                tokenInput.value = tokenFromQuery;
            }
            token = tokenFromQuery;
            request({ token });
        }



        if (!token) request();
    }, [searchParams]);


    return (<Box>
            <label for="token">Токен</label>
            <input type="text" placeholder="token" id="token"/>
            <label for="token">Сообщение</label>
            <input type="message" placeholder="message" id="message"/>
            <label for="file">Название файла</label>
            <input type="text" placeholder="file.name" id="file"/>
            <label for="date">Дата</label>
            <input type="date" id="date"/>
            <label for="error">Ошибка</label>
            <input type="text" placeholder="ok" id="error"/>
            <label for="source">Источник</label>
            <input type="text" placeholder="webcam" id="source"/>
            <Button onClick={() => parse_data()} variant="contained">
                    Отправить запрос
            </Button>
            <br></br><p>Логи загружаются постранично. Используйте параметры запроса для поиска.</p>
            <StudentsTable logFilters={logFilters} mode={4}/>
        </Box>);
}
